export default function Generic(data) {
    let generic = data || {};
    this.type = "Generic";
    this.reference = generic.reference;
    this.comment = generic.comment;
}